/**
 * @file Adding react app in html dom
 * @namespace index
 */
import React from "react"
import {Provider} from "react-redux"
import {BrowserRouter} from "react-router-dom"
import ReactDOM from "react-dom"
import "./index.scss"
import App from "./App"

import store from "./redux/store"

/**
 * empty function for clear console
 * @memberof index
 */
const noop = () => {}

if (process.env.NODE_ENV !== "development") {
  console.log = noop
  console.warn = noop
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
)
